import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { ChatWidget } from "@/components/ChatWidget";
import Start from "@/pages/Start";
import Leistungen from "@/pages/Leistungen";
import Balayage from "@/pages/Balayage";
import Frisuren from "@/pages/Frisuren";
import Team from "@/pages/Team";
import Galerie from "@/pages/Galerie";
import Karriere from "@/pages/Karriere";
import Kontakt from "@/pages/Kontakt";
import Anfragen from "@/pages/Anfragen";
import Extensions from "@/pages/Extensions";
import Locken from "@/pages/Locken";
import Hochsteckfrisuren from "@/pages/Hochsteckfrisuren";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Seo />
        <Layout>
          <Routes>
            <Route path="/" element={<Start />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/balayage" element={<Balayage />} />
            <Route path="/frisuren" element={<Frisuren />} />
            <Route path="/team" element={<Team />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/karriere" element={<Karriere />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/anfragen" element={<Anfragen />} />
            <Route path="/haar-extensions" element={<Extensions />} />
            <Route path="/lockiges-haar" element={<Locken />} />
            <Route path="/hochsteckfrisuren" element={<Hochsteckfrisuren />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="*" element={<Start />} />
          </Routes>
        </Layout>
        <ChatWidget />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
